<div class="lvi-content">
    <div class="avatar">
        <i class="nio icon-profil"></i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label">{{ data | user:'nomPrenomMatricule' }}</a>
        </div>
        <ul class="lvi-attrs">
            <li>
                <strong [translate]="'admin.entreprise.utilisateurs.internes.identifiant'"></strong>
                <span>{{ data.nomAcces }}</span>
            </li>
            <li *ngIf="data.orga">
                <strong [translate]="'admin.entreprise.utilisateurs.internes.serviceAffectation'"></strong>
                <span>{{ data | user:'orga' }}</span>
            </li>
            <li *ngIf="data.fonctions">
                <strong [translate]="'admin.entreprise.utilisateurs.internes.profils'"></strong>
                <span>{{ data | user:'fonctions' }}</span>
            </li>
            <li>
                <strong [translate]="'admin.entreprise.utilisateurs.internes.actif'"></strong>
                <span [translate]="data.actif ? 'global.oui' : 'global.non'"></span>
            </li>
        </ul>
    </div>
</div>
